import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';
import IncomeTaxCalculator from './components/IncomeTaxCalculator';
import DeductionFinder from './components/DeductionFinder';
import RefundCalculator from './components/RefundCalculator';
import W2vs1099Comparison from './components/W2vs1099Comparison';
import SelfEmploymentTax from './components/SelfEmploymentTax';
import CapitalGainsCalculator from './components/CapitalGainsCalculator';
import QuarterlyTaxEstimator from './components/QuarterlyTaxEstimator';
import WithholdingCalculator from './components/WithholdingCalculator';
import RetirementContribution from './components/RetirementContribution';
import StateTaxComparison from './components/StateTaxComparison';

export default function CalculatorPage() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const calculatorId = searchParams.get('id') || 'income-tax';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const renderCalculator = () => {
    switch (calculatorId) {
      case 'income-tax':
        return <IncomeTaxCalculator />;
      case 'deduction-finder':
        return <DeductionFinder />;
      case 'refund-calculator':
        return <RefundCalculator />;
      case 'w2-1099-comparison':
        return <W2vs1099Comparison />;
      case 'self-employment':
        return <SelfEmploymentTax />;
      case 'capital-gains':
        return <CapitalGainsCalculator />;
      case 'estimated-tax':
        return <QuarterlyTaxEstimator />;
      case 'withholding':
        return <WithholdingCalculator />;
      case 'retirement':
        return <RetirementContribution />;
      case 'state-tax':
        return <StateTaxComparison />;
      default:
        return <IncomeTaxCalculator />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation scrolled={scrolled} />
      <div className="pt-24 pb-20">
        {renderCalculator()}
      </div>
      <Footer />
    </div>
  );
}